import JeddleQuestion from './JeddleQuestion';

export default JeddleQuestion;
